import { $authHost, $host, $adminHost} from './index';

// @route   POST /addresses
// @desc    Create new brand
// @access  Private
export const addAddress = async values => {
  const res = await $adminHost.post('addresses', values).catch(err => {
    throw err.response;
  });
  return res;
};

// @route   PUT /addresses/:id
// @desc    Update existing brand
// @access  Private
export const updateAddress = async (id, values) => {
  const res = await $adminHost.put(`addresses/${id}`, values).catch(err => {
    throw err.response;
  });
  return res;
};

// @route   DELETE /addresses/:id
// @desc    DELETE existing brand
// @access  Private
export const deleteAddress = async customId => {
  const res = await $adminHost.delete(`addresses/${customId}`).catch(err => {
    throw err.response;
  });
  return res;
};

// @route   GET /addresses
// @desc    GET existing brand
// @access  Public
export const getAddresses = async () => {
  const res = await $host.get('addresses/getall').catch(err => {
    throw err.response;
  });
  return res;
};
